import { Injectable } from '@angular/core';
import { SeatingDetail } from './seating-detail.model';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';

export interface SeatingDetailState extends EntityState<SeatingDetail> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'seating-details', idKey: 'MemberId' })
export class SeatingDetailStore extends EntityStore<SeatingDetailState> {

  constructor() {
    super();
  }

}

